function adBlockDetected() {
	gtag('event', 'AdBlockDetected', {'event_category': 'AdBlockDetected', 'event_label': 'adBlockOn', 'value': true, 'ad_blockers': window.location.href});
}

if(typeof blockAdBlock === 'undefined') {
	adBlockDetected();
} else {
	blockAdBlock.onDetected(adBlockDetected);
}

